import React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const borderColor = '#AAAAAA';
const specialBorderColor = '#F3F3F4';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#F45B69',
        color: theme.palette.common.white,
        fontWeight: 700,
        border: `1px solid ${borderColor}`,
    },

    fontSize: 14,
    border: `1px solid ${borderColor}`,
    padding: '8px',
    textAlign: 'center',
    '&:first-child': {
        borderLeft: `1px solid ${specialBorderColor}`,
    },
    '&:last-child': {
        borderRight: `1px solid ${specialBorderColor}`,
    },
}));

const BoldTableCell = styled(StyledTableCell)(({ theme }) => ({
    fontWeight: 'bold',
}));

const VerticalDataCell = styled(StyledTableCell)(({ theme }) => ({
    writingMode: 'vertical-rl',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#CCE5E5',
    }
}));

const ProcessModuleTable = ({
    tableHeader,
    tableData
}) => {
    const columnCount = 20;

    return (
        <>
            <TableContainer sx={{ width: "100%", borderRadius: "13px" }}>
                <Table aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <BoldTableCell sx={{ textDecoration: 'underline' }} colSpan={columnCount}>{tableHeader}</BoldTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <StyledTableRow>
                            <BoldTableCell>Present- Location Name</BoldTableCell>
                            <BoldTableCell>Suggestion</BoldTableCell>
                            <VerticalDataCell >Bollards & Burried Vehicle Barriers</VerticalDataCell>
                            <VerticalDataCell>Boom Barriers</VerticalDataCell>
                            <VerticalDataCell>Full Body Scanner</VerticalDataCell>
                            <VerticalDataCell>Baggage Scanner</VerticalDataCell>
                            <VerticalDataCell>Mobile Sniffer</VerticalDataCell>
                            <VerticalDataCell>Turnstile</VerticalDataCell>
                            <VerticalDataCell>Parking Management System</VerticalDataCell>
                            <VerticalDataCell>Visitor Management System</VerticalDataCell>
                            <VerticalDataCell>Access Control System - RFID</VerticalDataCell>
                            <VerticalDataCell>Access Control System – IRIS</VerticalDataCell>
                            <VerticalDataCell>Access Control System – Biometric Fingerprint</VerticalDataCell>
                            <VerticalDataCell>IP Camera System with Video Analytics & Masking</VerticalDataCell>
                            <VerticalDataCell>IP Surveillance System</VerticalDataCell>
                            <VerticalDataCell>Digital Signage System / Mass Notification System</VerticalDataCell>
                            <VerticalDataCell>Lead Protection System / Bullet Proof System</VerticalDataCell>
                            <VerticalDataCell>Strong Room / Bunker</VerticalDataCell>
                            <VerticalDataCell>Evacuation System</VerticalDataCell>
                            <VerticalDataCell>Public Address System</VerticalDataCell>
                        </StyledTableRow>

                        {
                            tableData && tableData.map((elem) => {
                                return (
                                    <StyledTableRow>
                                        <StyledTableCell>{elem.title}</StyledTableCell>
                                        <StyledTableCell>{elem.suggestion}</StyledTableCell>
                                        <StyledTableCell>{elem.process1}</StyledTableCell>
                                        <StyledTableCell>{elem.process2}</StyledTableCell>
                                        <StyledTableCell>{elem.process3}</StyledTableCell>
                                        <StyledTableCell>{elem.process4}</StyledTableCell>
                                        <StyledTableCell>{elem.process5}</StyledTableCell>
                                        <StyledTableCell>{elem.process6}</StyledTableCell>
                                        <StyledTableCell>{elem.process7}</StyledTableCell>
                                        <StyledTableCell>{elem.process8}</StyledTableCell>
                                        <StyledTableCell>{elem.process9}</StyledTableCell>
                                        <StyledTableCell>{elem.process10}</StyledTableCell>
                                        <StyledTableCell>{elem.process11}</StyledTableCell>
                                        <StyledTableCell>{elem.process12}</StyledTableCell>
                                        <StyledTableCell>{elem.process13}</StyledTableCell>
                                        <StyledTableCell>{elem.process14}</StyledTableCell>
                                        <StyledTableCell>{elem.process15}</StyledTableCell>
                                        <StyledTableCell>{elem.process16}</StyledTableCell>
                                        <StyledTableCell>{elem.process17}</StyledTableCell>
                                        <StyledTableCell>{elem.process18}</StyledTableCell>
                                    </StyledTableRow>
                                )
                            })
                        }

                    </TableBody>
                </Table>
            </TableContainer>

            <TableContainer sx={{ width: "100%", paddingTop: "35px", borderRadius: "13px" }}>
                <Table aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <BoldTableCell sx={{ textDecoration: 'underline' }}>Note</BoldTableCell>
                            <StyledTableCell></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <StyledTableCell>R</StyledTableCell>
                            <StyledTableCell sx={{ textAlign: "left" }}>Required</StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <StyledTableCell>R1</StyledTableCell>
                            <StyledTableCell sx={{ textAlign: "left" }}>Required as Applicable</StyledTableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer >
        </>
    );
};

export default ProcessModuleTable;
